const configs: {
  host: string;
  servicePath?: string;
} = {
  host: process.env.REVIEWS_SERVICE_ENDPOINT,
  servicePath: 'api'
};

export default configs;
